(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2551],{

/***/ 85395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/finances",
      function () {
        return __webpack_require__(94546);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pages_company_finances_plan_page__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81386);

/* harmony default export */ __webpack_exports__["default"] = (pages_company_finances_plan_page__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,5555,9772,7334,3454,9774,2888,179], function() { return __webpack_exec__(85395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);